import { MutationTree } from "vuex";
import { RootState } from "@/models/states/RootState";

const mutations: MutationTree<RootState> = {};
export default mutations;
